import {
  AgxColumn,
  AgxRadioGroup,
  AgxTextInput,
} from '@urbanx/agx.ui-components2'
import { StaffUpdateServiceFeeInfoForCampaignRequestChangeType } from '@urbanx/agx.campaigns.client'
import { useEffect, useState } from 'react'

const editServiceFeeReasonOptions = [
  {
    label: 'UrbanX error',
    value: StaffUpdateServiceFeeInfoForCampaignRequestChangeType.UrbanXError,
  },
  {
    label: 'Free Sale',
    value: StaffUpdateServiceFeeInfoForCampaignRequestChangeType.FreeSale,
  },
  {
    label: 'Other',
    value: StaffUpdateServiceFeeInfoForCampaignRequestChangeType.Other,
  },
]

interface EditServiceFeeReasonProps {
  defaultChangeDetails?: ChangeDetails
  onChange?: (details: ChangeDetails) => void
}

export interface ChangeDetails {
  reasonType: StaffUpdateServiceFeeInfoForCampaignRequestChangeType
  reason?: string
}

const EditServiceFeeReason = ({
  defaultChangeDetails,
  onChange,
}: EditServiceFeeReasonProps) => {
  const [selectedReason, setSelectedReason] =
    useState<StaffUpdateServiceFeeInfoForCampaignRequestChangeType>(
      () =>
        defaultChangeDetails?.reasonType ??
        StaffUpdateServiceFeeInfoForCampaignRequestChangeType.UrbanXError
    )

  const [otherReasonText, setOtherReasonText] = useState<string>(
    () => defaultChangeDetails?.reason ?? ''
  )

  useEffect(() => {
    if (!onChange) return

    const updatedChangedDetails = {
      reasonType: selectedReason,
      reason:
        selectedReason ===
        StaffUpdateServiceFeeInfoForCampaignRequestChangeType.Other
          ? otherReasonText
          : undefined,
    }

    onChange(updatedChangedDetails)
  }, [selectedReason, otherReasonText, onChange])

  return (
    <AgxColumn fill gap={'spacing-lg'}>
      <AgxRadioGroup
        id="editServiceFeeReasonRadioGroup"
        layout="vertical"
        options={editServiceFeeReasonOptions}
        value={selectedReason}
        onChange={(value) => {
          if (value === selectedReason) return

          return setSelectedReason(
            value as StaffUpdateServiceFeeInfoForCampaignRequestChangeType
          )
        }}
        label="Reason *"
        subContent={
          selectedReason ===
            StaffUpdateServiceFeeInfoForCampaignRequestChangeType.Other && (
            <AgxColumn
              padding={{
                top: 'spacing-2xl',
                bottom: 'spacing-2xl',
                left: 'spacing-lg',
                right: 'spacing-lg',
              }}
              fill
            >
              <AgxTextInput
                id={'editServiceFeeReasonOtherInput'}
                type={'text'}
                defaultValue={otherReasonText}
                onChange={(value) => {
                  if (value === otherReasonText) return
                  return setOtherReasonText(value)
                }}
                required
                hideOptionalText
                stretch
                label="Reason *"
              />
            </AgxColumn>
          )
        }
      ></AgxRadioGroup>
    </AgxColumn>
  )
}

export default EditServiceFeeReason
